var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getFooterData) ? _c('footer', {
    class: [_vm.getRouteLeave ? 'disable' : '']
  }, [_c('div', {
    staticClass: "footer-container"
  }, [_c('div', {
    staticClass: "socials"
  }, [_c('ul', _vm._l((_vm.getFooterData.body.items), function(link) {
    return _c('li', {
      key: "social"
    }, [_c('a', {
      attrs: {
        "href": link.url,
        "target": "_blank"
      }
    }, [_c('i', {
      class: ("icon-" + (link.title))
    })])])
  }))]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("\n\t\t\tCopyright © All rights reserved.\n\t\t")])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18af04df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/common/footer/Footer.vue
// module id = nLB5
// module chunks = 1